import Vue from 'vue'

/**
 * Update purchase order unit price
 *
 * @return {Object}
 */

export default (payload) =>
  Vue.$http.post(`purchase/update-consolidated-price/`, { supplies: payload})
    .then(response => response.data)



// WEBPACK FOOTER //
// ./src/services/purchase/updatePurchaseOrder.js